export function getCurrencySymbol(currency: string): string {
    // Map currency codes to their symbols for the most common currencies worldwide
    const currencySymbols: Record<string, string> = {
        // Major Global Currencies
        USD: "$", // US Dollar
        EUR: "€", // Eurow
        GBP: "£", // British Pound
        JPY: "¥", // Japanese Yen
        CNY: "¥", // Chinese Yuan
        CHF: "CHF", // Swiss Franc

        // Americas
        CAD: "C$", // Canadian Dollar
        MXN: "Mex$", // Mexican Peso
        BRL: "R$", // Brazilian Real
        ARS: "$", // Argentine Peso
        COP: "$", // Colombian Peso
        CLP: "$", // Chilean Peso
        PEN: "S/", // Peruvian Sol
        UYU: "$U", // Uruguayan Peso

        // Europe
        RUB: "₽", // Russian Ruble
        PLN: "zł", // Polish Złoty
        SEK: "kr", // Swedish Krona
        NOK: "kr", // Norwegian Krone
        DKK: "kr", // Danish Krone
        CZK: "Kč", // Czech Koruna
        HUF: "Ft", // Hungarian Forint
        RON: "lei", // Romanian Leu
        BGN: "лв", // Bulgarian Lev
        HRK: "kn", // Croatian Kuna
        ISK: "kr", // Icelandic Króna

        // Asia-Pacific
        AUD: "A$", // Australian Dollar
        NZD: "NZ$", // New Zealand Dollar
        SGD: "S$", // Singapore Dollar
        HKD: "HK$", // Hong Kong Dollar
        KRW: "₩", // South Korean Won
        INR: "₹", // Indian Rupee
        IDR: "Rp", // Indonesian Rupiah
        MYR: "RM", // Malaysian Ringgit
        THB: "฿", // Thai Baht
        PHP: "₱", // Philippine Peso
        TWD: "NT$", // New Taiwan Dollar
        VND: "₫", // Vietnamese Dong

        // Middle East & Africa
        AED: "د.إ", // UAE Dirham
        SAR: "﷼", // Saudi Riyal
        ILS: "₪", // Israeli New Shekel
        TRY: "₺", // Turkish Lira
        ZAR: "R", // South African Rand
        EGP: "E£", // Egyptian Pound
        MAD: "MAD", // Moroccan Dirham
        KES: "KSh", // Kenyan Shilling
        NGN: "₦", // Nigerian Naira

        // Other Notable Currencies
        PKR: "₨", // Pakistani Rupee
        BDT: "৳", // Bangladeshi Taka
        LKR: "₨", // Sri Lankan Rupee
        NPR: "₨", // Nepalese Rupee
        KZT: "₸", // Kazakhstani Tenge
        UAH: "₴", // Ukrainian Hryvnia
        QAR: "﷼", // Qatari Riyal
        KWD: "د.ك", // Kuwaiti Dinar
        BHD: ".د.ب", // Bahraini Dinar
        OMR: "﷼", // Omani Rial
    };
    return currencySymbols[currency] || currency;
}
